import React, { useEffect, useState } from 'react'
import { EMPTY_OBJECT, getWalletScriptUrl } from '../../constants/globalConstants'
import PropTypes from 'prop-types'
import { noop } from 'jquery'
import { decryptionHandler, getFormattedAmount } from '../../utils/helper'
import { errorMessage } from '../../constants/errorMessage'
import MiniHeader from '../global/MiniHeader'
import { addEventLog } from '../../redux/actions/EventsLog'
import CONSTANTS from '../../redux/constants'
import { connect } from 'react-redux'
import NoData from '../NoData'
import { initialize } from './walletHelper'
import MobileGooglePayDC from './mobileGooglePayDC'
import Loader from '../../global/Loader'
import MobileGooglePayHL from './mobileGooglePayHL'

const MobileWalletButtons = (props) => {
    const {dispatch} = props
    const [data, setData] = useState(EMPTY_OBJECT)
    const [isLoading, setIsLoading] = useState(true)
    const [failedMessage, setErrorMessage] = useState('')
    const [displayError, setDisplayError] = useState('')
    const [mobilePay, setMobilePay] = useState('0')
    const [reqData, setReqData] = useState(EMPTY_OBJECT)
    const [page, setPage] = useState(0)
    const [response, setResponse] = useState(EMPTY_OBJECT)
    const [thankYouMessage, setThankYouMessage] = useState('')

    useEffect(() => {
        setPage(0)
        const urlParams = new URLSearchParams(window.location.search)
        const myParam = urlParams.get('q')
        if(myParam){
            setDisplayError(false)
            setErrorMessage('')
            const decodedData = decryptionHandler(myParam)
            let errObject = {
                payload: decodedData
            }
            dispatch(addEventLog(errObject, `${CONSTANTS?.DATA_FROM_URL} Data Received From URL`))
            setData(decodedData)
            setIsLoading(false)
            setReqData(JSON.parse(decodedData?.request || '{}'))
            const paymentType = decodedData?.payment_type_id || '2'
            const scriptUrls = getWalletScriptUrl(paymentType)
            const scriptArray = Object.keys(scriptUrls)?.map((item) => scriptUrls[item])
            initialize(scriptArray, paymentType, setMobilePay)
        }else{
            setErrorMessage(errorMessage?.errorinParams)
            setDisplayError(true)
        }
    },[])

  
    return (
        displayError ? <div className='main'>
            <MiniHeader title='PAYMENT DETAILS' noLoginIcon hideLogo/>
            <div>
                <NoData message={failedMessage}/>
            </div>
        </div> : 
        <div className='main'>
            <MiniHeader title={`${reqData ? (reqData?.ticket_number && data?.type != 'gated_session') ? 'EXTEND' : '' : ''} PAYMENT DETAILS`} noLoginIcon hideLogo/>
            {isLoading ? <Loader/> : reqData ? 
            <div>
                {page == 0 ? <div className='container'>
                    <center className='text-center pt-2 pb-2 mt-2'>Redirected to payment Gateway...</center>
                    {reqData?.rateBandDesc ? <div className='border-grey border border-2 border-primary border-opacity-50 rounded p-3 d-flex align-items-center justify-content-between my-3 cursor '>
                        {reqData?.rateBandDesc} <span className='fw-bold' >${Number(reqData?.total?.toString()?.replace(/,/g, ''))?.toFixed(2)} </span>
                    </div> :null }
                    
                    {reqData?.ticket_number || reqData?.license ? <div className='card rounded-lg shadow-lg mb-3'>
                        <div className='card-header'>
                            {reqData?.ticket_number ? <div className='fw-bold d-flex align-items-center justify-content-between my-3 cursor '>
                                Ticket Number <span className='fw-bold' >#{reqData?.ticket_number || '-'} </span>
                            </div> : null}
                            {reqData?.license ? <div className='fw-bold d-flex align-items-center justify-content-between my-3 cursor '>
                                License Plate <span className='fw-bold' >{reqData?.license || '-'} </span>
                            </div> : null}
                        </div>    
                    </div> : null }
                </div> : null}

                 {/*STEP 0 DISPLAY PAYMENT FORM & BUTTON */}
                {page == 0 ? <div className='container pb-2'>
                    <div className='card rounded-lg shadow-lg'>
                        <div className='card-header  d-flex justify-content-between'>
                            <p className='card-title text-primary m-0'>Price Breakdown</p><i className='fa fa-receipt'></i>
                        </div>
                        <div className='card-body'>
                            <div>
                                <table className='table table-borderless table-sm mb-0 pb-0'>
                                    <tbody>
                                        <tr>
                                            <td>Parking Amount</td>
                                            <td className='text-end'>${getFormattedAmount(data?.parking_amount)}</td>
                                        </tr>
                                        <tr>
                                            <td>Processing Fee</td>
                                            <td className='text-end'>${getFormattedAmount(reqData?.processing_fee)}</td>
                                        </tr>
                                        <tr>
                                            <td>Tax</td>
                                            <td className='text-end'>${getFormattedAmount(reqData?.tax_fee)}</td>
                                        </tr>
                                        {Number(reqData?.discount_amount) > 0 && reqData?.promocode != null ?
                                            <tr>
                                                <td>Validated Amount {reqData?.discount_hours ? '('+(reqData?.discount_hours)+' hrs)' : null}</td>
                                                <td className='text-end'>${getFormattedAmount(reqData?.discount_amount)}</td>
                                            </tr> : null
                                        }
                                    </tbody>
                                    
                                </table>
                            </div>
                        </div>
                        <div className='card-footer'>
                            <div>
                                <div className='row justify-content-between'>
                                    <div className='col-auto'>
                                        <p className='mb-0 text-primary'>Amount Due</p><small> (Tax Included)</small>
                                    </div>
                                    <div className='col-auto text-end'>
                                        <h4 className='mb-0'>${getFormattedAmount(reqData?.total)}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> : null}
                {/*STEP 0 DISPLAY PAYMENT FORM & BUTTON */}

                {isLoading ? 
                    <Loader/>
                : page == 0 ? 
                mobilePay == '2' ? 
                    <MobileGooglePayDC
                        setThankYouMessage={setThankYouMessage}
                        setResponse={setResponse}
                        data={data}
                        setPage={setPage}
                        page={page}
                        setDisplayError={setDisplayError}
                        setErrorMessage={setErrorMessage}
                        displayError={displayError}
                        failedMessage={failedMessage}
                    /> 
                : mobilePay == '3' ? 
                    <MobileGooglePayHL
                        setThankYouMessage={setThankYouMessage}
                        setResponse={setResponse}
                        data={data}
                        setPage={setPage}
                        page={page}
                        setDisplayError={setDisplayError}
                        setErrorMessage={setErrorMessage}
                        displayError={displayError}
                        failedMessage={failedMessage}
                    /> : null : null}

                {/*STEP 1 DISPLAY SUCCESS MESSAGE */}
                {page == 1 ? <div className="container mb-3 mt-4">
                    <div className=" border-2 border border-success border-opacity-50 p-2 text-center rounded">
                        <h4 className="text-success fw-bold" >Thank You</h4>
                    <p className="m-0 text-secondary mb-4" >{thankYouMessage || ''}</p>

                    <table className="table small">
                        <tbody>
                            <tr>
                                <th className="text-start">Ticket Number: </th>
                                <td className="text-end fw-bold">#{response?.data?.ticket_number}</td>
                            </tr>
                            <tr>
                                <th className="text-start pb-2 pt-2">Payment Status: </th>
                                <td className="text-end text-success fw-bold pb-2 pt-2">Paid</td>
                            </tr>
                            <tr>
                                <th className="text-start">Amount Paid: </th>
                                <td className="text-end fw-bold">${getFormattedAmount(reqData?.total)}</td>
                            </tr>
                        </tbody>
                    </table>
                    
                    </div>
                </div> : null}
                {/*STEP 1 DISPLAY SUCCESS MESSAGE */}

                {/*STEP 2 DISPLAY FAILURE MESSAGE */}
                {page == 2 ? <div className="container mb-3 mt-4">
                    <div className=" border-2 border border-danger border-opacity-50 p-2 text-center rounded">
                        <h4 className="text-danger fw-bold" >Payment Failed!</h4>
                    <p className="m-0 text-secondary mb-4" >{failedMessage ? failedMessage : errorMessage?.somethingWentWrong}</p>

                    <table className="table small">
                        <tbody>
                            {reqData?.ticket_number ? <tr>
                                <th className="text-start">Ticket Number: </th>
                                <td className="text-end fw-bold">#{reqData?.ticket_number}</td>
                            </tr> : null}
                            <tr>
                                <th className="text-start pb-2">Payment Status: </th>
                                <td className="text-end text-danger fw-bold pb-2">Failed</td>
                            </tr>
                            <tr>
                                <th className="text-start">License Plate: </th>
                                <td className="text-end no-break">{reqData?.license || '-'}</td>
                            </tr>
                        </tbody>
                    </table>
                    
                    </div>
                </div> : null}
                {/*STEP 2 DISPLAY FAILURE MESSAGE */}
            
            </div> : 
            <div className='d-flex align-items-center justify-content-center'>
                <center className='text-center text-danger p-2 border-grey border border-2 border-danger border-opacity-50 rounded'>{errorMessage?.somethingWentWrong}</center>
            </div>}

            
        </div>
    )
}
MobileWalletButtons.propTypes = {
    dispatch: PropTypes.func,
    faciltyData: PropTypes.object, 
    getValues: PropTypes.func, 
    onSubmit: PropTypes.func,
    setIsSubmittingForm: PropTypes.func,
    notify: PropTypes.func,
}

MobileWalletButtons.defaulProps = {
    dispatch: noop,
    faciltyData: EMPTY_OBJECT,
    getValues: noop, 
    onSubmit: noop,
    setIsSubmittingForm: noop,
    notify: noop,
}

function mapStateToProps() {
    return {
    }
}

export default connect(mapStateToProps)(MobileWalletButtons)